export default [{
  connections: 1,
  url: 'http://192.168.1.113/fourB',
  transferPerSec: '9.65KB',
  requestsPerSec: 91.46,
  requestsTotal: 921,
  durationActual: '10.07s',
  transferTotal: '97.14KB',
  latencyAvg: '5.66ms',
  latencyStdev: '5.20ms',
  latencyMax: '77.95ms',
  latencyStdevPerc: 95.85,
  rpsAvg: '91.89',
  rpsStdev: '22.21',
  rpsMax: '120.00',
  rpsStdevPerc: 81,
  latency50: '4.29ms',
  latency75: '5.70ms',
  latency90: '7.17ms',
  latency99: '29.92ms'
},
{
  connections: 2,
  url: 'http://192.168.1.113/fourB',
  transferPerSec: '15.70KB',
  requestsPerSec: 148.85,
  requestsTotal: 1495,
  durationActual: '10.04s',
  transferTotal: '157.68KB',
  latencyAvg: '7.22ms',
  latencyStdev: '5.10ms',
  latencyMax: '72.60ms',
  latencyStdevPerc: 95.84,
  rpsAvg: '149.35',
  rpsStdev: '25.30',
  rpsMax: '181.00',
  rpsStdevPerc: 78,
  latency50: '6.10ms',
  latency75: '7.40ms',
  latency90: '9.13ms',
  latency99: '32.26ms'
},
{
  connections: 8,
  url: 'http://192.168.1.113/fourB',
  transferPerSec: '19.30KB',
  requestsPerSec: 183.04,
  requestsTotal: 1839,
  durationActual: '10.05s',
  transferTotal: '193.96KB',
  latencyAvg: '23.14ms',
  latencyStdev: '8.44ms',
  latencyMax: '118.75ms',
  latencyStdevPerc: 80.68,
  rpsAvg: '183.92',
  rpsStdev: '30.43',
  rpsMax: '222.00',
  rpsStdevPerc: 84,
  latency50: '22.62ms',
  latency75: '27.01ms',
  latency90: '30.92ms',
  latency99: '51.56ms'
},
{
  connections: 1,
  url: 'http://192.168.1.113/fourKB',
  transferPerSec: '290.73KB',
  requestsPerSec: 72.49,
  requestsTotal: 729,
  durationActual: '10.06s',
  transferTotal: '2.86MB',
  latencyAvg: '8.21ms',
  latencyStdev: '4.29ms',
  latencyMax: '69.99ms',
  latencyStdevPerc: 95.24,
  rpsAvg: '72.64',
  rpsStdev: '11.77',
  rpsMax: '90.00',
  rpsStdevPerc: 75,
  latency50: '6.97ms',
  latency75: '8.73ms',
  latency90: '10.20ms',
  latency99: '26.22ms'
},
{
  connections: 2,
  url: 'http://192.168.1.113/fourKB',
  transferPerSec: '462.09KB',
  requestsPerSec: 115.21,
  requestsTotal: 1156,
  durationActual: '10.03s',
  transferTotal: '4.53MB',
  latencyAvg: '10.17ms',
  latencyStdev: '4.56ms',
  latencyMax: '59.60ms',
  latencyStdevPerc: 93.92,
  rpsAvg: '115.64',
  rpsStdev: '18.45',
  rpsMax: '141.00',
  rpsStdevPerc: 80,
  latency50: '8.86ms',
  latency75: '10.47ms',
  latency90: '12.94ms',
  latency99: '34.96ms'
},
{
  connections: 8,
  url: 'http://192.168.1.113/fourKB',
  transferPerSec: '566.15KB',
  requestsPerSec: 141.16,
  requestsTotal: 1418,
  durationActual: '10.05s',
  transferTotal: '5.55MB',
  latencyAvg: '32.78ms',
  latencyStdev: '10.62ms',
  latencyMax: '90.50ms',
  latencyStdevPerc: 72.78,
  rpsAvg: '141.76',
  rpsStdev: '19.01',
  rpsMax: '170.00',
  rpsStdevPerc: 75,
  latency50: '30.45ms',
  latency75: '38.54ms',
  latency90: '46.58ms',
  latency99: '69.63ms'
},
{
  connections: 1,
  url: 'http://192.168.1.113/fourKBloop',
  transferPerSec: '172.73KB',
  requestsPerSec: 43.07,
  requestsTotal: 431,
  durationActual: '10.01s',
  transferTotal: '1.69MB',
  latencyAvg: '17.57ms',
  latencyStdev: '3.65ms',
  latencyMax: '53.15ms',
  latencyStdevPerc: 95.15,
  rpsAvg: '43.04',
  rpsStdev: '6.81',
  rpsMax: '50.00',
  rpsStdevPerc: 66.67,
  latency50: '16.45ms',
  latency75: '17.96ms',
  latency90: '19.51ms',
  latency99: '34.87ms'
},
{
  connections: 2,
  url: 'http://192.168.1.113/fourKBloop',
  transferPerSec: '271.73KB',
  requestsPerSec: 67.71,
  requestsTotal: 681,
  durationActual: '10.06s',
  transferTotal: '2.67MB',
  latencyAvg: '23.84ms',
  latencyStdev: '8.16ms',
  latencyMax: '106.95ms',
  latencyStdevPerc: 95.51,
  rpsAvg: '67.84',
  rpsStdev: '11.14',
  rpsMax: '80.00',
  rpsStdevPerc: 68,
  latency50: '22.37ms',
  latency75: '23.53ms',
  latency90: '26.81ms',
  latency99: '72.62ms'
},
{
  connections: 8,
  url: 'http://192.168.1.113/fourKBloop',
  transferPerSec: '39.38KB',
  requestsPerSec: 9.82,
  requestsTotal: 99,
  durationActual: '10.08s',
  transferTotal: '397.06KB',
  latencyAvg: '80.60ms',
  latencyStdev: '25.38ms',
  latencyMax: '147.05ms',
  latencyStdevPerc: 75.76,
  rpsAvg: '61.44',
  rpsStdev: '10.89',
  rpsMax: '70.00',
  rpsStdevPerc: 87.5,
  latency50: '70.24ms',
  latency75: '78.83ms',
  latency90: '128.89ms',
  latency99: '147.05ms'
}];
